// TODO talvez apagar esse mixin

/**
 * @mixin
 * @description Esse é o mixins para lidar com os anexos do Business Plan, a ultima aba de 'Memória da Cálculo e Evidências'. Por enquanto não há regras de negócios.
 * @requires {@link BusinessPlanCore} requer o mixin base
 * @example
 * mixins: [BusinessPlanEvidence]
 */
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {}
};
